import api from "./api";

const AssetsImageAPI = {
    getAll: () => api.get(`/assets-image/all`),
    update: (data) => api.post(`/assets-image/update`, data)
};

export default AssetsImageAPI;